import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { pushToDataLayer } from '../../utils/gtm';

const GTMPathTracker = () => {
  const location = useLocation();

  useEffect(() => {
    pushToDataLayer({
      event: 'page_view',
      page_title: document.title, 
      page_path: location.pathname + location.search,
    });
  }, [location]);

  return null; 
};

export default GTMPathTracker;